<template>
  <div class="gropProfile">
    <div class="navtop">
    </div>
    <!-- <div class="clear"></div> -->
    <div class="Tpage">
      <div id="PageLeft">
        <div class="Tit">
          <!-- <img src="../../assets/image/zi_left_b.png"> -->
          <div class="big">党群工作</div>
        </div>

        <div class="sort">
          <div
            class="navMainInner"
            :class="{ active: active == item.entTChannelUuid }"
            v-for="(item, index) in navSubList"
            :key="index"
            @click="handleTab(item, index)"
          >
            {{ item.name }}
          </div>
        </div>
      </div>
      <div id="PageRight">
        <div class="nav">
          <!-- <div class="l" style="font-size: 14px;">{{pathtitle}}</div> -->
          <div class="r">
            <i class="el-icon-house" style="font-size:16px;margin-right:10px"></i>
            <span> 您当前的位置： </span>
            <span>
              <router-link style="font-size:16px" to="/homePage">首页 <span> &nbsp;> </span>  </router-link>
            </span>  
            <span style="font-size:16px" @click="handleTab(indexPage)" class="textTitle">{{mathedTitle}}  </span>
            <span style="font-size:16px" v-if="pathtitle!=''"> &nbsp;> {{pathtitle}} </span>
          </div>
        </div>

        <div class="content">
          <div class="view">
            
            <list-detail v-if="isDeail" ref="listDetail" :id="listId"></list-detail>
            <new-list v-if="isList" ref="newList" :id="listId"></new-list>
            <div v-if="isArtDel">
              <news-details ref="listDetail" :parentId="parentId" :id="actlistId"></news-details>
            </div>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getChildChannel , } from '@/api/common'
import listDetail from '@/components/listDetail/index.vue'
import newList from '@/components/newList/index.vue'
import newsDetails from '@/components/newsDetails/index.vue'
export default {
   components: {
    listDetail,
    newList,
    newsDetails
  },
  data() {
    return {  
      indexPage:{},
      actlistId:'',
      parentId:'',
      isShowv:false,
      listId: '',
      isDeail: false,
      isList: false,    
      isArtDel:false,
      fullpath:'',
      active: '00600002',
      pathtitle:'',
      mathedTitle:'党群工作',
      navSubList: [
      ],
      entTArticleUuid:''
    }
  },
  computed: {
  
  },
  mounted() {
    var _this = this

    _this.active = _this.$route.params.id
    _this.listId = _this.$route.params.id
    if(_this.$route.query.entTArticleUuid){
      _this.entTArticleUuid = JSON.parse(_this.$route.query.entTArticleUuid)
      _this.actlistId = _this.entTArticleUuid
      _this.isArtDel = true
    }
    _this.getSubGrop()
  },
  watch: {
    $route(val) {
      console.log(val)
      this.entTArticleUuid = ''
      if(this.$route.query.entTArticleUuid){
        this.entTArticleUuid = JSON.parse(this.$route.query.entTArticleUuid)
        this.actlistId = this.entTArticleUuid
        this.isArtDel = true
      }
      this.getSubGrop()
    }
  },
  methods: {
    // 打开左右箭头
    openShow(){
      this.isShowv = true
    },
    closeShow(){
      this.isShowv = false
    },
    // 获取二级栏目
    getSubGrop() {
      var _this = this
      let data = {
        applicationUuid: _this.webId,
        parentUuid: '0060'
      }
      getChildChannel(data).then(res => {
        const { code, data } = res
        if (code === 1 && data) {
          _this.navSubList = data
          _this.indexPage = _this.navSubList[0]
          data.length &&
            data.forEach(line => {
              if (line.entTChannelUuid == _this.listId) {
                _this.pathtitle = line.name
                if(_this.entTArticleUuid!=''){
                  this.isArtDel = true
                  this.actlistId = this.entTArticleUuid
                  this.isDeail = false
                  this.isList = false
                }else{
                  if (line.catalog == 1) {
                    this.isDeail = true
                    this.isArtDel = false
                    this.isList = false
                  } else {
                    this.isList = true
                    this.isDeail = false
                    this.isArtDel = false
                  }
                }
              }
            })
        }
      })
    },
    handleTab(item) {
      this.isDeail = false
      this.isList = false
      this.$router.push(`/businessUnit/${item.entTChannelUuid}`)
      this.pathtitle = item.name
      this.active = item.entTChannelUuid
      this.listId = item.entTChannelUuid
      this.$nextTick(() => {
        if (item.catalog == 1) {
          this.isDeail = true
          this.isArtDel = false
        } else {
          this.isList = true
          this.isArtDel = false
        }
      })
    }
  },
}
</script>

<style lang="scss">
.navtop{
  background: rgb(242,242,242);
  height: 44px;
  position: absolute;
  width: 100%;
}
// 轮播背景大图
.gropProfile .ziHead {
  width: 100%;
  height: auto;
  overflow: hidden;
}

.gropProfile .ziHead .swiper-container {
  .swiper-wrapper {
    .swiper-slide {
      width: 100%;
      text-align: center;
      position: relative;
      overflow: hidden;
      height: 540px;
    }
  }
}
.gropProfile .ziHead .swiper-button-prev,
.swiper-container-rtl .swiper-button-next {
  background-image: url("../../assets/image/leftimg.png");
  background-size: cover;
  position: absolute;
  top: 45%;
  margin-top: -15px;
  width: 30px;
  height: 50px;
  z-index: 89;
  opacity: 0.5;
}
.gropProfile .ziHead .swiper-button-next,
.swiper-container-rtl .swiper-button-prev {
  background-image: url("../../assets/image/rightimg.png");
  background-size: cover;
  position: absolute;
  top: 45%;
  margin-top: -15px;
  width: 30px;
  height: 50px;
  z-index: 89;
  opacity: 0.5;
}
.gropProfile .ziHead .swiper-button-prev {
  left: -40px;
  transition: all 0.3s linear;
  -moz-transition: 0.3s all linear;
  -webkit-transition: 0.3s all linear;
  -o-transition: 0.3s all linear;
  -ms-transition: 0.3s all linear;
}.gropProfile .ziHead .swiper-button-next {
  right: -40px;
  transition: all 0.3s linear;
  -moz-transition: 0.3s all linear;
  -webkit-transition: 0.3s all linear;
  -o-transition: 0.3s all linear;
  -ms-transition: 0.3s all linear;
}
.gropProfile .ziHead .swiper-button-prev.active {
  left: 10px;
}.gropProfile .ziHead .swiper-button-next.active {
  right: 10px;
}
.clear {
  width: 100%;
  height: 20px;
  overflow: hidden;
  display: block;
  clear: both;
}
.Tpage {
  width: 1200px;
  overflow: hidden;
  margin: 0px auto;
  margin-top: 3px;
  position:relative;
}
#PageLeft {
  width: 235px;
  float: left;
  overflow: hidden;
}
#PageLeft .Tit {
  width: 235px;
  height: 105px;
  color: #FFFFFF;
  z-index: 9999999;
  background: #0062b3 url(../../assets/image/zi_left_b.png) 35px center no-repeat;
  margin-bottom: 2px;
}
#PageLeft .Tit .img {
  width: 64px;
  height: 73px;
  margin: 26px auto 0px auto;
  float: left;
}
img {
  display: inline-block;
  border: none;
}
.Tit .big {
  width: 140px;
  height: 105px;
  line-height: 105px;
  font-size: 26px;
  float: right;
  margin-left: 95px;
  display: inline-block;
}
#PageLeft .Tit .samll {
  width: 100%;
  height: 24px;
  line-height: 24px;
  text-align: center;
  font-size: 14px;
  text-align: center;
  color: #97bde1;
  margin-top: 10px;
}
#PageLeft .sort {
  width: 100%;
  overflow: hidden;
}
#PageLeft .sort .navMainInner {
  width: 100%;
  height: 50px;
  display: block;
  background-color: #0062b3;
  line-height: 50px;
  text-align: center;
  font-size: 14px;
  color:#ffffff;
  font-weight: bolder;
  margin-bottom: 2px;
}
.navMainInner:hover {
  background-color: #d4d4d4 !important;
  color: #0062b3 !important;
}
.navMainInner.active {
  background-color: #d4d4d4 !important;
  color: #0062b3 !important;
}
#PageRight {
  width: 930px;
  float: right;
  overflow: hidden;
}
#PageRight .nav {
  width: 100%;
  height: 42px;
}
#PageRight .nav .r {
  height: 44px;
  line-height: 44px;
  font-size: 14px;
  color: #888888;
  cursor: pointer;
}
#PageRight .nav .r a {
  font-size: 12px;
  color: #9a9a9a;
}
.content {
  font-size: 16px;
  line-height: 30px;
  padding: 0px;
}
.content .view {
  padding: 0px 10px;
}
</style>

